import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";

const Paginator = ({ items, setDisplayItems }) => {
  // Aca seleccionamos cuantos items vemos por pagina.
  const [itemsPerPage] = useState(8);

  const pageCount = Math.ceil(items.length / itemsPerPage);
  const [pageNumber, setPageNumber] = useState(0);

  const changePage = ({ selected }) => {
    const desde = selected * itemsPerPage;
    let hasta = desde + itemsPerPage;
    if (hasta > items.length && items.length !== 0) hasta = items.length;
    setDisplayItems(items.slice(desde, hasta));

    const valor = selected < pageNumber ? pageNumber - 1 : selected;
    setPageNumber(valor);
  };

  useEffect(() => {
    changePage({ selected: pageNumber });
  }, [items, items.length]);

  return (
    <div className="d-flex justify-content-center pagination pagination-sm">
      {items.length === 0 ? (
        <div> La lista esta vacía </div>
      ) : (
        <ReactPaginate
          breakLabel="..."
          previousLabel={"Anterior"}
          nextLabel={"Siguiente"}
            pageCount={pageCount}
          onPageChange={changePage}
          containerClassName="pagination"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          disabledClassName="page-item disabled"
          disabledLinkClassName="page-link"
          activeClassName="page-item active"
          activeLinkClassName="page-link"
          pageClassName="page-item"
          pageLinkClassName="page-link"
        />
      )}
    </div>
  );
};

export default Paginator;
